import { useAdminSelectedSchool } from '../../utils/adminSchoolContext'
import StudentListTabContent from './StudentListTabContent'

const AdminStudentListWrapper = () => {
  const selectedSchool = useAdminSelectedSchool()

  if (!selectedSchool) {
    return (
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-8 text-center">
        <h3 className="text-lg font-medium text-blue-900">
          画面上部のボタンから学校を選択してください
        </h3>
      </div>
    )
  }

  return <StudentListTabContent schoolId={selectedSchool.id} />
}

export default AdminStudentListWrapper
